import script from "./LanguageSuggestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSuggestion.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSuggestion.vue?vue&type=style&index=0&id=202d0d0c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-202d0d0c"]])

export default __exports__